<script setup lang="ts">
defineProps<{ text: string }>();
</script>

<template>
  <span class="feature-highlight-label">
    <span class="text">{{ text }}</span>
    <span class="badge">{{ $t("featureHighlight.badge") }}</span>
  </span>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";
@use "@/styles/mixins/utils";

.feature-highlight-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.text {
  @include utils.ellipsis;
}

.badge {
  @include typography.extra-small("bold");

  flex-shrink: 0;
  padding: 3px 5px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  // Noto Sans JP's tall ascent pushes caps above the middle; trimming to the cap height centers them
  text-box: trim-both cap alphabetic;
  color: colors.$text;
  background-color: colors.$alternative-yellow;
}
</style>
